import { Button } from "@/components/ui/button";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Trash2 } from "lucide-react";
import { SECTOR_LABELS, SHIPPING_TYPES } from "../constants";
import { SECTOR_EMAILS_LABELS } from "../messages";
import { SectorRecipient } from "../types";

interface DeleteRecipientModalProps {
  recipient: SectorRecipient;
  onConfirm: (recipient: SectorRecipient) => void;
}

export function DeleteRecipientModal({
  recipient,
  onConfirm,
}: DeleteRecipientModalProps): JSX.Element {
  const { handleModal } = useDialogModal();

  const typeLabels: string = SHIPPING_TYPES.filter((type) =>
    recipient.shipping_types.includes(type.value)
  )
    .map((type) => type.label)
    .join(", ");

  const handleDelete = (): void => {
    onConfirm(recipient);
    handleModal({ isOpen: false });
  };

  return (
    <div className="w-full max-w-md space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
          <Trash2 className="h-5 w-5 text-red-600" />
        </div>
        <div>
          <p className="font-medium text-gray-900">
            {SECTOR_LABELS[recipient.sector]}
            {recipient.name ? ` — ${recipient.name}` : ""}
          </p>
          <p className="text-xs text-gray-500">
            {recipient.email}
            {typeLabels ? ` • Tipos: ${typeLabels}` : ""}
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-700">
        {SECTOR_EMAILS_LABELS.DELETE_EXPLANATION}
      </p>

      <p className="rounded-md bg-gray-50 p-3 text-xs text-gray-600">
        {SECTOR_EMAILS_LABELS.DELETE_PAUSE_HINT}
      </p>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={() => handleModal({ isOpen: false })}>
          {SECTOR_EMAILS_LABELS.CANCEL}
        </Button>
        <Button
          onClick={handleDelete}
          className="bg-red-600 text-white hover:bg-red-700"
        >
          {SECTOR_EMAILS_LABELS.DELETE}
        </Button>
      </div>
    </div>
  );
}
